import { render, staticRenderFns } from "./ReportSolutions.vue?vue&type=template&id=024dd460&"
import script from "./ReportSolutions.vue?vue&type=script&lang=js&"
export * from "./ReportSolutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports